// Module
var code = "<div class=\"gc-copyright\">Made with <a style=\"cursor: pointer; color: inherit !important;\" href=\"https://pagepilot.fabbuilder.com\" target=\"_blank\">Page Pilot</a></div> ";
// Exports
export default code;